/* eslint-disable no-fallthrough */
import dotProp from 'dot-prop-immutable';

import * as actionTypes from './actiontypes';
import { GLOBAL_UPDATE_MESSAGE } from '../page_details/actiontypes';
import states from './states';

const feedback_details = (state = states.feedback_details, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_FEEDBACK_STATE:
      return dotProp.set(state, action.path, action.payload);

    case actionTypes.FEEDBACK_LOADING: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          feedback_loading: true,
          feedback_loaded: false,
        }
      };
    }

    case actionTypes.FEEDBACK_LOADED: {
      return {
        ...state,
        feedbacks: action.payload && action.payload.feedbacks ? action.payload.feedbacks : [...state.feedbacks],
        loaders: {
          ...state.loaders,
          feedback_loading: false,
          feedback_loaded: true,
        }
      };
    }

    case actionTypes.FEEDBACK_ERROR: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          feedback_loading: false,
          feedback_loaded: false,
        }
      }
    }

    case actionTypes.FEEDBACK_CHATLOG_LOADED: {
      return {
        ...state,
        active_feedback_data: {
          ...state.active_feedback_data,
          messages: action.payload.chatLogs ? action.payload.chatLogs : [],
        }
      };
    }

    case GLOBAL_UPDATE_MESSAGE: {
      if (action.payload.psid && action.payload.chatlogId && action.payload.changedValue && state.active_feedback_data.active_feedback_item.psid === action.payload.psid) {
        let messages = [...state.active_feedback_data.messages];
        const index = messages.findIndex(message => (message.chatlogId && message.chatlogId === action.payload.chatlogId));
        if (index !== -1) {
          messages = [
            ...state.active_feedback_data.messages.slice(0, index),
            {
              ...messages[index],
              ...action.payload.changedValue
            },
            ...state.active_feedback_data.messages.slice(index + 1)
          ];
        }
        return {
          ...state,
          active_feedback_data: {
            ...state.active_feedback_data,
            messages,
          }
        };
      }
    }

    default:
      return state;
  }
}

export default feedback_details;



// WEBPACK FOOTER //
// ./src/data/redux/feedback_details/reducers.js